import axios from "axios";
import qs from "qs";
import Vue from "vue";
import {
    parseISO,
} from "date-fns";
import {
    format,
    utcToZonedTime
} from "date-fns-tz";
const initialState = {
    admissionSearchOptions: {
		all:1,
		page:0,
//		created_before:null,
//		created_on_or_after:null,
	},
	searchedAdmissions:{},
	searchedAdmissionsCount:0,
}

export const state = { ...initialState};

export const actions = {
    resetAdmissionSearchOptions(context){
        context.commit("setAdmissionSearchOptions",
			{
				all:1,
				page:0,
//				created_before:null,
//				created_on_or_after:null,
			}
        );
    },

    updateAdmissionSearchOptions(context,options) {
        context.commit("setAdmissionSearchOptions", options);
    },

	async searchAdmissions(context){

		if(Object.keys(state.admissionSearchOptions).length===0){
			return;
		}

		state.admissionSearchOptions.page = 0;

		var obj = {...state.admissionSearchOptions};

		const formatInTimeZone = (date, fmt, tz) =>
			format(utcToZonedTime(date, tz),
			fmt, {
				timeZone: tz
		});
		if(state.admissionSearchOptions["created_on_or_after"]){
			var dateCopy1 = parseISO(state.admissionSearchOptions["created_on_or_after"].toISOString());
			obj["created_on_or_after"] = formatInTimeZone(dateCopy1, "yyyy-MM-dd HH:mm", "UTC");
		}
		if(state.admissionSearchOptions["created_before"]){
			var dateCopy2 = parseISO(state.admissionSearchOptions["created_before"].toISOString());
			obj["created_before"] = formatInTimeZone(dateCopy2, "yyyy-MM-dd HH:mm", "UTC");
		}
		

		return axios.get("/api/1/admissions", {
			params: obj
		}).then(function(response){
			console.log(response.data)
			if(response.data.success){
				
				context.commit("setSearchedAdmissions",response.data.result.admissions);
			}
			
		});

	},

	async searchAdmissionsAppend(context){

		if(Object.keys(state.admissionSearchOptions).length===0){
			return;
		}

		return axios.get("/api/1/admissions", {
			params: state.admissionSearchOptions
		}).then(function(response){
			if(response.data.success){
				context.commit("appendSearchedAdmissions",response.data.result.admissions);
			}
		});

	},

	async searchAdmissionsTotal(context){

		if(Object.keys(state.admissionSearchOptions).length===0){
			return;
		}

		
		var obj = {...state.admissionSearchOptions};

		const formatInTimeZone = (date, fmt, tz) =>
			format(utcToZonedTime(date, tz),
			fmt, {
				timeZone: tz
		});
		if(state.admissionSearchOptions["created_on_or_after"]){
			var dateCopy1 = parseISO(state.admissionSearchOptions["created_on_or_after"].toISOString());
			obj["created_on_or_after"] = formatInTimeZone(dateCopy1, "yyyy-MM-dd HH:mm", "UTC");
		}
		if(state.admissionSearchOptions["created_before"]){
			var dateCopy2 = parseISO(state.admissionSearchOptions["created_before"].toISOString());
			obj["created_before"] = formatInTimeZone(dateCopy2, "yyyy-MM-dd HH:mm", "UTC");
		}

		var getCountParams = JSON.parse(JSON.stringify(obj));

		getCountParams.count_only = 1;


		return axios.get("/api/1/admissions", {
			params: getCountParams
		}).then(function(response){
			
			if(response.data.success){
				context.commit("setSearchedAdmissionsCount",response.data.result.count);
			}
		});

	},
}

export const mutations = {
 
    setAdmissionSearchOptions(state,searchOptions){
        state.admissionSearchOptions = searchOptions;
    },

	setSearchedAdmissions(state,data){
		//state.searchedAdmissions = data;
		state.searchedAdmissions = {};

		for(var i=0; i<data.length; i++){
			var team_id = data[i].list_id;

			if(data[i].ainc){
				data[i].ainc = "1";
			}

			if(state.searchedAdmissions[team_id]){
				state.searchedAdmissions[team_id].push(data[i])
			}else {
				var array = [];
				array.push(data[i])
				Vue.set(state.searchedAdmissions, team_id, array)
			}
		}
	},

	setSearchedAdmissionsCount(state,data){
		state.searchedAdmissionsCount = data;
	},

	appendSearchedAdmissions(state,data){
		for(var i=0; i<data.length; i++){
			var team_id = data[i].list_id;

			if(data[i].ainc){
				data[i].ainc = "1";
			}

			if(state.searchedAdmissions[team_id]){
				state.searchedAdmissions[team_id].push(data[i]);


			}else {
				var array = [];
				array.push(data[i])
				Vue.set(state.searchedAdmissions, team_id, array)
			}
		}
	}

}

const getters = {
    admissionSearchOptions(state){
        return state.admissionSearchOptions;
    },
	searchedAdmissions(state){
		return state.searchedAdmissions;
	},
	searchedAdmissionsCount(state){
		return state.searchedAdmissionsCount;
	},
}

export default {
    state,
    actions,
    mutations,
    getters
};